import { useContext } from "react";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableContext from "context/table/tableContext";
import { DASHBOARD, TABLE_NAMES } from "shared";

import CompaniesBar from "./CompaniesBar";
import DashboardBar from "./DashboardBar";
import DeviceGroupsBar from "./DeviceGroupsBar";
import DeviceModelsBar from "./DeviceModelsBar";
import DevicesBar from "./DevicesBar";
import FilesBar from "./FilesBar";
import LicensesBar from "./LicensesBar";
import ProductCodesBar from "./ProductCodesBar";
import RolesBar from "./RolesBar";
import TaskGroupsBar from "./TaskGroupsBar";
import { ActionBarProps } from "./types";
import UsersBar from "./UsersBar";

const ActionBar = ({ name }: ActionBarProps) => {
    const { gray50, gray200, gray900, textPlaceholder } = colors;

    const { tableName } = useContext(TableContext);

    const contentName = name ?? tableName;

    const renderContent = () => {
        switch (contentName) {
            case TABLE_NAMES.TaskGroups:
                return <TaskGroupsBar />;
            case TABLE_NAMES.Companies:
                return <CompaniesBar />;
            case TABLE_NAMES.Users:
                return <UsersBar />;
            case TABLE_NAMES.Roles:
                return <RolesBar />;
            case TABLE_NAMES.Devices:
                return <DevicesBar />;
            case TABLE_NAMES.Files:
                return <FilesBar />;
            case TABLE_NAMES.DeviceGroups:
                return <DeviceGroupsBar />;
            case TABLE_NAMES.ProductCodes:
                return <ProductCodesBar />;
            case TABLE_NAMES.DesktopLicenses:
                return <LicensesBar />;
            case TABLE_NAMES.DeviceModels:
            case TABLE_NAMES.DeviceModelTaskCompatibilities:
                return <DeviceModelsBar />;
            default:
                return <DashboardBar />;
        }
    };

    const isDashboard = contentName === DASHBOARD;

    const getPadding = () => {
        if (isDashboard) return "22px 0px 22px 24px";

        return "16px 24px 15px 24px";
    };

    const padding = getPadding();

    return (
        <section>
            <div
                css={css({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: gray50,
                    borderBottom: isDashboard ? "none" : `1px solid ${gray200}`,
                    padding,

                    h1: {
                        fontSize: "20px",
                        fontWeight: "500",
                        lineHeight: "24px",
                        letterSpacing: "0.15px",

                        "& > span:nth-of-type(1)": {
                            color: gray900
                        },

                        "& > span:nth-of-type(2)": {
                            color: textPlaceholder,
                            marginLeft: "5px"
                        }
                    },

                    "@media(max-width: 599px)": {
                        display: "block"
                    }
                })}
            >
                {renderContent()}
            </div>
        </section>
    );
};

export default ActionBar;
